"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreZB = void 0;
var react_1 = __importDefault(require("react"));
require("./morezb.less");
/**
 * 更多自选指标
 * @returns
 */
function MoreZB(props) {
    var change = function (e) {
        props.onChange(e.target.value);
    };
    // console.log(props.onIndex)
    return (react_1.default.createElement("div", { className: "morezb" },
        "\u81EA\u9009\u6307\u6807\uFF1A",
        react_1.default.createElement("select", { onChange: change, value: props.onIndex || 0 }, props.data.map(function (v, index) {
            return react_1.default.createElement("option", { key: index, value: index }, v.title);
        }))));
}
exports.MoreZB = MoreZB;
